import { Components, Theme } from '@mui/material';
import { Spacing3 } from '../spacing';

export const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: {
      marginRight: Spacing3,
    },
  },
};
